module.exports = __webpack_public_path__ + "img/relacionescolor-auroquim.9d6224b5.png";